/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo, useState } from "react";
import "./css/Dialog.css";

export default function Dialog({
  title,
  children,
  acceptLabel,
  onAccept,
  style,
  size,
  declineLabel,
  onDecline,
  onClose,
  className,
  variant,
  show,
  ...props
}) {
  const computedClassName = [
    "dialog-wrapper",
    "modal",
    "fade",
    (show && "in") || "",
    ...className.split(" "),
  ]
    .join(" ")
    .trim();
  const computedStyle = {
    ...((!!style && style) || {}),
    ...((show && {
      paddingRight: "17px",
      display: "block",
    }) || { display: "none" }),
  };
  return (
    <div
      className={computedClassName}
      tabIndex="-1"
      role="dialog"
      style={computedStyle}
    >
      <div
        className={["modal-dialog", `modal-${size}`, variant].join(" ").trim()}
        role="document"
      >
        <div className="modal-content">
          {!!title && (
            <div className="modal-header">
              <h4 className="modal-title">{title}</h4>
            </div>
          )}
          <div className="modal-body">{children}</div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default"
              onClick={(event) => {
                !!onDecline &&
                  onDecline instanceof Function &&
                  onDecline(event);
              }}
            >
              {declineLabel}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={(event) => {
                !!onAccept && onAccept instanceof Function && onAccept(event);
              }}
            >
              {acceptLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

Dialog.defaultProps = {
  className: "",
  size: "sm",
  variant: "",
  onAccept: () => {
    console.debug("Aceptado");
  },
  onDecline: () => {
    console.debug("Declinado");
  },
};

export function useDialog(props) {
  const [state, setState] = useState(props);
  const handleAcceptClick = (event) => {
    event.preventDefault();
    !!state.onAccept && state.onAccept(event);
  };
  const handleDeclineHelp = (event) => {
    event.preventDefault();
    !!state.onDecline && state.onDecline(event);
  };
  const display = (
    title,
    message,
    acceptLabel,
    declineLabel,
    onAccept,
    onDecline,
  ) => {
    setState({
      ...props,
      title,
      message,
      acceptLabel,
      declineLabel,
      onAccept,
      onDecline,
      showing: true,
    });
  };
  const close = () => {
    setState({ ...props, showing: false });
  };
  const component = useMemo(
    () => (
      <Dialog
        acceptLabel={state?.acceptLabel}
        onAccept={handleAcceptClick}
        declineLabel={state?.declineLabel}
        onDecline={handleDeclineHelp}
        show={state?.showing}
        title={state?.title}
        variant={state?.variant}
        size="lg"
      >
        {state.message}
        {/* {state.message instanceof Function */}
      </Dialog>
    ),
    [
      handleAcceptClick,
      handleDeclineHelp,
      state?.acceptLabel,
      state?.declineLabel,
      state?.message,
      state?.showing,
      state?.title,
      state?.variant,
    ],
  );
  return { component, display, close };
}
